// extracted by mini-css-extract-plugin
module.exports = {"lds-dual-ring":"style_lds-dual-ring__2n_iK","lds-dual-ring-after":"style_lds-dual-ring-after__w_qdo"};